import { Autocomplete, Box, Button, Divider, Grid, IconButton, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { isEmpty, isNumberEmpty, OfferType, printDebugLog, RESYMBOL } from "../../constants/Constants";
import { fmtMoney } from "../../constants/commonUtils";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DialogBox from "../../global/DialogBox";
import ViewListIcon from '@mui/icons-material/ViewList';
import { ESTIMATED_ADULTS } from "../../constants/ConfigConstant";
//fetch-combo-food-details"
const BuffetForm = ({
    stayType, totalDaysStay,
    totalBuffetDetails, setTotalBuffetDetails, configBuffetType, billPayInfo,
    setBillPayInfo, keyMapInformation,
    comboList, fetchAllComboFoodList, setSnpComponent, disabledOperation }) => {

    useEffect(() => {
        printDebugLog("BuffetForm useEffect:", comboList);
    }, [comboList]);

    const [selectedCombo, setSelectedCombo] = useState(null);
    const [singleBuffetItem, setSingleBuffetItem] = useState({});
    const [isEdit, setIsEdit] = useState(false);
    const canSelectRate = stayType !== -1 && totalDaysStay > 0;
    const [showDialog, setShowDialog] = useState(false);

    function upsertRestoItem() {

        setTotalBuffetDetails(prev => {
            const items = [...prev.items];
            const idx = items.findIndex(it => String(it.id) === String(selectedCombo?.id) && it.buffetType === singleBuffetItem.buffetType);

            if (idx >= 0) {
                items[idx] = { ...items[idx], ...singleBuffetItem, };
                return {
                    ...prev,
                    items,
                    added: items.length > 0,
                };
            } else {
                items.push(singleBuffetItem);
                return {
                    ...prev,
                    items,
                    totalSize: prev.totalSize + 1,
                    added: true,
                };
            }
        });
    }

    function deleteRestoItem(r) {
        printDebugLog("deleteRestoItem", r);
        setTotalBuffetDetails(prev => {
            const nextItems = prev.items.filter(it => !(String(it.id) === String(r.id) && it.buffetType === r.buffetType));
            const removed = nextItems.length !== prev.items.length;

            return {
                ...prev,
                items: nextItems,
                totalSize: removed ? Math.max(0, prev.totalSize - 1) : prev.totalSize,
                added: nextItems.length > 0 ? prev.added : false,
            };
        });
    }


    const doTotal = (mTotalRestaurantPrice) => {
        printDebugLog("doTotal", mTotalRestaurantPrice, billPayInfo);
        let mCgstAmt = 0.0;
        let mSgstAmt = 0.0;
        let mRoundOff = 0.0;
        let mSubTotal = 0.0;
        let mFinalPrice = 0.0;
        const parseCgst = Number(billPayInfo?.cgst ?? 0) / 100;
        const parseSgst = Number(billPayInfo?.sgst ?? 0) / 100;
        const parseOfferDenom = Number(billPayInfo?.takenDenom ?? OfferType.No_Offer);
        const parseOfferAmt = Number(billPayInfo?.takenOffrAmt ?? 0);

        mSubTotal = Number(billPayInfo?.totalRoomPrice ?? 0)
            + Number(billPayInfo?.totalBanquetPrice ?? 0) + Number(billPayInfo?.totalExtraPrice ?? 0);

        mSubTotal = (mSubTotal * totalDaysStay) + mTotalRestaurantPrice;
        mFinalPrice = mSubTotal;
        if (parseOfferDenom === OfferType.Flat) {
            mFinalPrice -= parseOfferAmt;
        } else if (parseOfferDenom === OfferType.Percentage) {
            mFinalPrice -= (mFinalPrice * parseOfferAmt / 100);
        }
        if (billPayInfo?.gstAllowed ?? true) {
            mCgstAmt = (mFinalPrice * parseCgst);
            mSgstAmt = (mFinalPrice * parseSgst);
        }
        mFinalPrice = mFinalPrice + mCgstAmt + mSgstAmt;
        mRoundOff = mFinalPrice.toFixed() - mFinalPrice;
        mFinalPrice = mFinalPrice + mRoundOff;
        const pendingAmt = billPayInfo?.paymentInitiated ?? false ? billPayInfo?.pendingAmt ?? 0 : mFinalPrice;

        setBillPayInfo(prev => ({
            ...prev,
            totalRestaurantBillPrice: mTotalRestaurantPrice,
            cgstAmt: mCgstAmt,
            sgstAmt: mSgstAmt,
            roundOff: mRoundOff,
            totalPrice: mSubTotal,
            finalPrice: mFinalPrice,
            pendingAmt: pendingAmt,
        }));
    }

    const handleAddOrUpdate = () => {
        printDebugLog("handleAddOrUpdate", selectedCombo, singleBuffetItem);
        if (!selectedCombo) {
            setSnpComponent(prev => ({
                ...prev,
                snackBarOpen: true,
                snackBarMsg: "Please select rate card",
            }))
            return;
        }
        if (isNumberEmpty(singleBuffetItem?.quantity)) {
            setSnpComponent(prev => ({
                ...prev,
                snackBarOpen: true,
                snackBarMsg: "Please enter how many plates",
            }))
            return;
        }
        let oldPrice = 0.0;
        const oldIndex = totalBuffetDetails.items.findIndex(item => item.id === singleBuffetItem?.id && item.buffetType === singleBuffetItem?.buffetType);
        if (oldIndex !== -1) {
            oldPrice = totalBuffetDetails.items[oldIndex].tAmt || 0;
        }
        const mTotalRestaurantPrice = Number(billPayInfo?.totalRestaurantBillPrice ?? 0) + Number(singleBuffetItem?.tAmt ?? 0) - oldPrice;
        doTotal(mTotalRestaurantPrice);

        upsertRestoItem();

        setSelectedCombo(null);
        setSingleBuffetItem(null);
        setSnpComponent(prev => ({
            ...prev,
            snackBarOpen: true,
            snackBarMsg: `${isEdit ? "Updated" : "Created"} Successfully`,
        }))
        setIsEdit(false);
    }

    const handleDeleteCurrent = () => {
        printDebugLog("handleDeleteCurrent", singleBuffetItem);
        handleDeleteRow(singleBuffetItem);
    }

    const handleEditRow = (r) => {
        if (billPayInfo?.paymentInitiated ?? false) {
            setSnpComponent(prev => ({
                ...prev,
                snackBarOpen: true,
                snackBarMsg: "Paid bill cannot be edited",
            }))
            return;
        }
        if (disabledOperation) {
            setSnpComponent(prev => ({
                ...prev,
                snackBarOpen: true,
                snackBarMsg: "Cancelled bill cannot be deleted",
            }));
            return;
        }
        if ((comboList?.length ?? 0) <= 0) {
            setSnpComponent(prev => ({
                ...prev,
                snackBarOpen: true,
                snackBarMsg: "Please fetch buffet details , then click on item",
            }))
            return;
        }
        setIsEdit(true);
        setSingleBuffetItem(r);
        const matchedItem = comboList && comboList.find(item => (
            r.id === String(item.id)
        )
        );
        printDebugLog("handleEditRow", matchedItem);
        if (matchedItem) {
            setSelectedCombo({
                ...matchedItem,
                itemCount: matchedItem.itemList?.length ?? 0
            });
        }
    }

    const handleDeleteRow = (r) => {
        if (billPayInfo?.paymentInitiated ?? false) {
            setSnpComponent(prev => ({
                ...prev,
                snackBarOpen: true,
                snackBarMsg: "Paid bill cannot be deleted",
            }))
            return;
        }
        if (disabledOperation) {
            setSnpComponent(prev => ({
                ...prev,
                snackBarOpen: true,
                snackBarMsg: "Cancelled bill cannot be deleted",
            }));
            return;
        }
        printDebugLog("handleDeleteCurrent", r);
        const mTotalRestaurantPrice = Number(billPayInfo?.totalRestaurantBillPrice ?? 0) - Number(r?.tAmt ?? 0);
        doTotal(mTotalRestaurantPrice);
        deleteRestoItem(r);
        setSelectedCombo(null);
        setSingleBuffetItem(null);
        setIsEdit(false);
        setSnpComponent(prev => ({
            ...prev,
            snackBarOpen: true,
            snackBarMsg: `Deleted Successfully`,
        }))
    }

    const renderDialogBuffetItem = () => {
        return (
            <TableContainer component={Paper} elevation={1} sx={{
                maxHeight: 300,
                overflowY: "auto",
            }}
            >
                <Table aria-label="extra-orders-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">Item Name</TableCell>
                            <TableCell align="center">Quantity</TableCell>
                            <TableCell align="center">Total Price</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {selectedCombo?.itemList.length === 0 ? (
                            <TableRow>
                                <TableCell align="center" colSpan={7}>
                                    <Typography variant="body2" color="text.secondary">
                                        No items yet. Add some above.
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            selectedCombo?.itemList.map((r) => (
                                <TableRow key={`${r.id}`}>
                                    <TableCell align="center">{r.name}</TableCell>
                                    <TableCell align="center">{r.itemCount}</TableCell>
                                    <TableCell align="center">{`${RESYMBOL} ${r.amount}`}</TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }

    const renderDialogAction = () => {
        return (
            <Button variant="contained" color="primary" onPointerDown={() => setShowDialog(false)} >
                Dismiss
            </Button>
        )
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Paper
                    elevation={4}
                    autoHeight
                    sx={{
                        borderRadius: 2,
                        p: 2,
                        backgroundColor: "#d9d9bc",
                    }}>

                    <Grid container spacing={2}>
                        <Grid item xs={12} md={3} sm={4}>
                            <Button size="small"
                                variant="contained" disabled={disabledOperation} onPointerDown={() => fetchAllComboFoodList()}>
                                Fetch Buffet Details
                            </Button>
                        </Grid>
                        {
                            (configBuffetType && configBuffetType?.length > 0) &&
                            <Grid item xs={12} md={4} sm={6} lg={4}>
                                <Autocomplete
                                    id="bufffet-select"
                                    options={configBuffetType}
                                    autoHighlight
                                    variant="filled"
                                    size="small"
                                    fullWidth
                                    disabled={disabledOperation}
                                    onChange={(e, option) => {
                                        if (option) {
                                            setSingleBuffetItem(prev => ({
                                                ...prev, buffetType: option,
                                            }))
                                        } else {
                                            setSingleBuffetItem(prev => ({
                                                ...prev, buffetType: "",
                                            }))
                                        }
                                    }}
                                    isOptionEqualToValue={(option, value) => option === value}
                                    getOptionLabel={(option) => option ?? ""}
                                    value={singleBuffetItem?.buffetType ?? null}
                                    renderOption={(props, option) => {
                                        return (
                                            <Box
                                                component="li"
                                                {...props}
                                            >
                                                {option}
                                            </Box>
                                        );
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select Buffet Time"
                                            inputProps={{
                                                ...params.inputProps,
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                        }
                        <Grid item xs={12} md={4} sm={6}>
                            <Autocomplete
                                id="room-select"
                                options={comboList}
                                autoHighlight
                                variant="filled"
                                size="small"
                                fullWidth
                                disabled={disabledOperation}
                                onChange={(e, option) => {
                                    if (!canSelectRate) {
                                        setSnpComponent(prev => ({ ...prev, snackBarOpen: true, snackBarMsg: "Please save the Date Selection Form" }));
                                        return;
                                    }
                                    if (option) {
                                        if (isEmpty(singleBuffetItem?.buffetType)) {
                                            setSnpComponent(prev => ({ ...prev, snackBarOpen: true, snackBarMsg: "Please select Buffet Time" }));
                                            return;
                                        }
                                        const matchedItem = totalBuffetDetails?.items?.find(item => (
                                            option.id === String(item.id) && singleBuffetItem.buffetType === item.buffetType
                                        )
                                        );
                                        if (matchedItem) {
                                            setIsEdit(true);
                                            setSingleBuffetItem(matchedItem);
                                        } else {
                                            const sAmt = Number(option.finalAmount) ?? 0;
                                            const parseQuantity = Number(keyMapInformation?.get(ESTIMATED_ADULTS) ?? 0);
                                            const tPrice = parseQuantity * sAmt;
                                            setSingleBuffetItem(prev => ({
                                                ...prev, id: option.id,
                                                comboName: option.comboName,
                                                amount: sAmt,
                                                itemCount: option.itemList?.length ?? 0,
                                                quantity: keyMapInformation?.get(ESTIMATED_ADULTS) ?? "",
                                                tAmt: tPrice,
                                            }))
                                        }
                                        setSelectedCombo(prev => ({
                                            ...prev, ...option,
                                            itemCount: option.itemList?.length ?? 0
                                        }));
                                    } else {
                                        setSelectedCombo(null);
                                        setSingleBuffetItem(null)
                                    }
                                }}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                getOptionLabel={(option) => option ? option?.comboName ?? "" : ""}
                                value={selectedCombo ?? null}
                                renderOption={(props, option) => {
                                    return (
                                        <Box
                                            component="li"
                                            {...props}
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "flex-start",
                                                padding: "6px 12px",
                                                backgroundColor: "transparent",
                                                borderRadius: "6px",
                                                cursor: "pointer",
                                                "&:hover": {
                                                    backgroundColor: "#f0f0f0",
                                                },
                                            }}
                                        >
                                            {/* Option roomType */}
                                            <span
                                                style={{
                                                    color: "#000",
                                                    fontWeight: "400",
                                                    fontFamily: "sans-serif",
                                                    fontSize: "14px",
                                                }}
                                            >
                                                {`${option.comboName}${isNumberEmpty(option.finalAmount) ? "" : `(₹${fmtMoney(option.finalAmount)})`}`}
                                            </span>
                                        </Box>
                                    );
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select Buffet"
                                        inputProps={{
                                            ...params.inputProps,
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Divider sx={{ my: 2 }} />
                        </Grid>
                        {
                            selectedCombo &&
                            <Grid item xs={12}>
                                <IconButton
                                    size="medium"
                                    aria-label="view"
                                    onPointerDown={() => setShowDialog(true)}
                                >
                                    <ViewListIcon fontSize="medium" />
                                    <p style={{ fontFamily: "sans-serif", fontSize: "16px" }}>{`Total Items: ${selectedCombo?.itemCount ?? 0}`}</p>
                                </IconButton>
                            </Grid>
                        }

                        {
                            selectedCombo &&
                            <Grid item xs={12} md={4}>
                                <TextField
                                    fullWidth
                                    variant="filled"
                                    size="small"
                                    label="Item Name"
                                    value={selectedCombo?.comboName ?? ""}
                                    disabled
                                />
                            </Grid>
                        }

                        {
                            selectedCombo &&
                            <Grid item xs={12} md={4}>
                                <TextField
                                    fullWidth
                                    variant="filled"
                                    size="small"
                                    label="Price per plate"
                                    value={selectedCombo?.finalAmount ?? ""}
                                    disabled
                                />
                            </Grid>
                        }

                        {
                            selectedCombo &&
                            <Grid item xs={12} md={4}>
                                <TextField
                                    fullWidth
                                    variant="filled"
                                    size="small"
                                    type="number"
                                    label="Enter total Plate"
                                    value={singleBuffetItem?.quantity ?? ""}
                                    onChange={(e) => {
                                        const parseVal = Number(e.target.value) ?? 0;
                                        const tPrice = parseVal * Number(selectedCombo?.finalAmount ?? 0);
                                        if (!isNumberEmpty(e.target.value)) {
                                            setSingleBuffetItem(prev => ({
                                                ...prev, quantity: Number(e.target.value),
                                                tAmt: tPrice,
                                            }))
                                        } else {
                                            setSingleBuffetItem(prev => ({
                                                ...prev, quantity: "",
                                                tAmt: tPrice
                                            }))
                                        }
                                    }}
                                    inputProps={{ min: 0 }}
                                />
                            </Grid>
                        }
                    </Grid>
                </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
                <Stack direction="row" spacing={1} sx={{ height: "100%" }} alignItems="center" justifyContent="center">
                    <Button variant="contained" disabled={disabledOperation} onPointerDown={() => handleAddOrUpdate()}>
                        {isEdit ? "Update" : "Add"}
                    </Button>
                    {
                        isEdit &&
                        <Button
                            variant="outlined"
                            color="error"
                            disabled={disabledOperation}
                            onPointerDown={() => handleDeleteCurrent()}
                        >
                            Delete
                        </Button>
                    }
                    <Button variant="text" onPointerDown={() => {
                        setSelectedCombo(null);
                        setSingleBuffetItem(null);
                        setIsEdit(false);
                    }}>Reset</Button>
                </Stack>
            </Grid>

            <Grid item xs={12}>
                <TableContainer component={Paper} elevation={3} sx={{
                    maxHeight: 300,
                    overflowY: "auto",
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
                    border: "none",
                    borderRadius: 2,
                }}
                >
                    <Table aria-label="extra-orders-table">
                        <TableHead>
                            <TableRow sx={{
                                backgroundColor: "#01333e",
                                "& .MuiTableCell-root": {
                                    color: "#fff",
                                    fontWeight: "bold",
                                    fontSize: "0.8rem",
                                    padding: "6px 8px",
                                    borderBottom: "none",
                                },
                            }}>
                                <TableCell align="center">Buffet Time</TableCell>
                                <TableCell align="center">Item Name</TableCell>
                                <TableCell align="center">Price per plate</TableCell>
                                <TableCell align="center">Quantity</TableCell>
                                <TableCell align="center">Total Price</TableCell>
                                <TableCell align="center">Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {totalBuffetDetails?.items.length === 0 ? (
                                <TableRow>
                                    <TableCell align="center" colSpan={7}>
                                        <Typography variant="body2" color="text.secondary">
                                            No items yet. Add some above.
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            ) : (
                                totalBuffetDetails?.items.map((r) => (
                                    <TableRow key={`${r.id}::${r.comboName}`}>
                                        <TableCell align="center">{r.buffetType}</TableCell>
                                        <TableCell align="center">{r.comboName}</TableCell>
                                        <TableCell align="center">{`${RESYMBOL} ${r.amount}`}</TableCell>
                                        <TableCell align="center">{r.quantity}</TableCell>
                                        <TableCell align="center">{`${RESYMBOL} ${r.tAmt}`}</TableCell>
                                        <TableCell align="center">
                                            <Stack direction="row" spacing={1} justifyContent="center">
                                                <IconButton
                                                    size="small"
                                                    aria-label="edit"
                                                    onPointerDown={() => handleEditRow(r)}
                                                >
                                                    <EditIcon fontSize="small" />
                                                </IconButton>
                                                <IconButton
                                                    size="small"
                                                    aria-label="delete"
                                                    onPointerDown={() => handleDeleteRow(r)}
                                                >
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            </Stack>
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>

            <DialogBox showDialog={showDialog}
                title={"Item List"}
                onClose={() => setShowDialog(false)}
                dialogContent={renderDialogBuffetItem()}
                dialogActions={renderDialogAction()} />
        </Grid>
    );
}

export { BuffetForm };
